import React from 'react';
import {useQuery} from '@tanstack/react-query';

import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {
  ListPageTrackingEvent,
  trackFeatureFlagListPageAction,
  TrackingEventSource,
} from 'apps/feature-flags/src/tracking';
import {useFeatureFlagStore} from 'apps/feature-flags/src/store';
import {useFeatureFlagsApi} from 'apps/feature-flags/src/api/feature-flags';

export const useQueryFeatureFlagList = (projectId: number) => {
  const setFeatureFlagList = useFeatureFlagStore((state) => state.setFeatureFlagList);
  const {listFeatureFlags} = useFeatureFlagsApi({projectId});

  const {isError, error, isSuccess, data} = useQuery({
    queryKey: [`featureFlags`, projectId],
    queryFn: listFeatureFlags,
  });

  React.useEffect(() => {
    if (isSuccess && data) {
      setFeatureFlagList(data);
    }

    trackFeatureFlagListPageAction({
      event: ListPageTrackingEvent.ListLoaded,
      source: TrackingEventSource.ListPageMain,
      props: {
        isSuccess,
        numberOfFeatureFlags: data?.length || 0,
      },
    });
  }, [isSuccess, data, setFeatureFlagList]);

  React.useEffect(() => {
    if (isError) {
      addToast({
        message: error.message,
        type: ToastType.ERROR,
      });
    }
  }, [isError, error]);
};
